import { Button, Divider, Flex, Spin } from 'antd'
import { useState } from 'react'

import { useTreatmentServiceGetAccessRequestsListEndpoint } from 'src/api/queries'
import { EpidemiologyCaseAccessRequestStatus } from 'src/api/requests'
import { Text } from 'src/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'

import { EpidemiologyRequestsModal } from './EpidemiologyRequestsModal'
import { useStyles } from './styles'

export const NewEpidemiologyRequests = () => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const { userData } = useUser()

  const [isOpen, setIsOpen] = useState(false)

  const onToggle = () => setIsOpen((prev) => !prev)

  const { data, isLoading } = useTreatmentServiceGetAccessRequestsListEndpoint({
    institutionId: userData?.currentLegalEntityId,
    status: EpidemiologyCaseAccessRequestStatus.NEW
  })

  if (isLoading) return <Spin spinning fullscreen />

  if (!data || data.totalCount === 0) return

  return (
    <>
      <Flex className={styles.card} align="center" justify="space-between">
        <Text size="xl" weight={700}>
          {data?.totalCount === 1
            ? t('epidemiology.access_request')
            : t('epidemiology.access_requests', { count: data?.totalCount })}
        </Text>

        <Button type="link" onClick={onToggle}>
          {t('common.see_all_list')}
        </Button>
      </Flex>

      <Divider />

      {isOpen && <EpidemiologyRequestsModal onCancel={onToggle} />}
    </>
  )
}
